// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1lm8m","productName":"Table_productName__34t7R"};